var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('portal', {
    attrs: {
      "to": "top-bar-right"
    }
  }, [_c('div', {
    staticClass: "flex justify-right"
  }, [_c('YButton', {
    staticClass: "btn btn-blue",
    attrs: {
      "is-loading": _vm.isCreating
    },
    on: {
      "click": _vm.createNewCampaign
    }
  }, [_vm._v(" New Campaign ")])], 1)]), _c('CampaignsTableWrapper')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }